import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AsyncStatus } from "../../models/async-status";
import { AccountAtAGlance } from "../../models/accounts-at-a-glance/account-at-a-glance";
import { getAccountsAtAGlance } from "../../services/accounts-at-a-glance";

export const fetchAccountsAtAGlance = createAsyncThunk(
  "fetch-accounts-at-a-glance",
  async (
    { planId, empId, role }: { planId: number; empId: number; role: string },
    thunkApi
  ) => {
    return getAccountsAtAGlance(planId, empId, role);
  }
);

type State = {
  accountsAtAGlance: AccountAtAGlance[];
  status: AsyncStatus;
};

const initialState: State = {
  accountsAtAGlance: [],
  status: AsyncStatus.not_fetched,
};

const accountsAtAGlanceSlice = createSlice({
  name: "accountsAtAGlance",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchAccountsAtAGlance.pending, (state, action) => {
      return { ...state, status: AsyncStatus.loading };
    });
    builder.addCase(fetchAccountsAtAGlance.fulfilled, (state, action) => {
      return {
        ...state,
        accountsAtAGlance: action.payload,
        status: AsyncStatus.done,
      };
    });
    builder.addCase(fetchAccountsAtAGlance.rejected, (state, action) => {
      return {
        ...state,
        status: AsyncStatus.error,
      };
    });
    builder.addDefaultCase((state, action) => state);
  },
});

export default accountsAtAGlanceSlice.reducer;
